export const PRESENTARION_VIDEO = "PRESENTARION_VIDEO";
export const PRESENTARION_VIDEO_DESKTOP = "PRESENTARION_VIDEO_DESKTOP";
export const THANKS_VIDEO = "THANKS_VIDEO";
export const THANKS_VIDEO_DESKTOP = "THANKS_VIDEO_DESKTOP";